import React, { useState, useEffect } from 'react';
// core components
import {  Button } from "reactstrap";
import { connect } from "react-redux";
import { compose } from "redux";
import InputLabel from "@material-ui/core/InputLabel";
import {
  updatePassword
} from "../../store/actions/vendor/Vendor";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import {  Typography } from "@material-ui/core";




function EditPassword(props){

  const [password,setPassword]=useState(null);
  const [oldPassword,setOldPassword]=useState(null);


const  handleChange = (e) => {
    if (e.target) {
      if(e.target.name=="password")
     setPassword(e.target.value);
     else if(e.target.name=="oldPassword")
     setOldPassword(e.target.value);
    }
  };

 const onSave = () => {
    if (oldPassword&&password) {
      props.updatePassword({ oldPassword, password });
    }
  };

  
    return (
      <>
       <Typography>Edit Password</Typography>
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <FormControl
                style={{ width: "100%" }}
              >
                   <InputLabel style={{ color: "#AAAAAA" }}>Old Password</InputLabel>
                <TextField
                  required
                  id="oldPassword"
                  label="Old Password"
                  name="oldPassword"
                  fullWidth
                  type="password"                 
                  value={oldPassword}  
                  onChange={handleChange}      
                />
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <FormControl
                style={{ width: "100%" }}
              >
                <InputLabel style={{ color: "#AAAAAA" }}>New Password</InputLabel>
                <TextField
                  required
                  id="password"
                  label="New Password"
                  name="password"
                  fullWidth
                  type="password"                 
                  value={password}  
                  onChange={handleChange}      
                />
              </FormControl>
            </GridItem>
            <GridItem
              xs={12}
              sm={12}
              md={3}
              style={{ justifyContent: "center" }}
            >
              <Button onClick={onSave}  variant="contained" color="primary" size='sm'  className='mt-2'>
                Update Password
              </Button>
            </GridItem>
          </GridContainer>
      
      </>
    );
  
}

const mapStateWithProps = (state) => {
  let commissionType=""
    let commissionValue=0
    if(state.vendor&&state.vendor.vendorDetail)
   {
    commissionType=state.vendor.vendorDetail.commissionType;
     commissionValue=state.vendor.vendorDetail.commissionValue;
   }
  return({
  commissionType,
  commissionValue
})};
const mapDispatchWithProps = (dispatch) => {
  return {
    updatePassword: (data) => dispatch(updatePassword(data)),
  };
};

export default compose(
  connect(mapStateWithProps, mapDispatchWithProps)
)(EditPassword);
